import { useSelector } from 'react-redux'
import { Panel } from '../../../common/panel'
import { selectSubsidiaryIds } from '../store/slice'
import { downloadSubsidiary } from '../store/thunk'
import { SubsidiaryTable } from './SubsidiaryTable'

export const Subsidiaries = ({ organizationId }) => {
  const ids = useSelector(selectSubsidiaryIds)

  return (
    <Panel
      id="subsidiaries"
      isI18n
      label="companyAnalysis.ownershipAndGroup.SUBSIDIARIES"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadSubsidiary({ OrganizationId: organizationId }),
      }}
    >
      <SubsidiaryTable />
    </Panel>
  )
}
